import React, { useEffect, useRef, useState } from "react";
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";
import { Popup } from "@progress/kendo-react-popup";
import { useUserOrganizationsStore } from "store";
import { ICON_NAMES } from "utils/constant";
import UserOrganization from "./HomePageItem";
import { getAlertsApi, getUserDefaultOrganizationApi } from "api/user";
import { Button } from "@progress/kendo-react-buttons";
import { useClickOutside, useEscapeKey } from "hooks/hooks";
import { OrganizationType } from "interface/user";
import UserSetting from "./userprofile/UserSetting";
import Notification from "./Notification";
import { AlertMessage } from "interface/alert";

const HeaderItem: React.FC = () => {
	const [showSetting, setShowSetting] = useState(false);
	const [showOrganizations, setShowOrganizations] = useState(false);
	const [showNotification, setShowNotification] = useState(false);
	const { defaultOrg, setDefault } = useUserOrganizationsStore();
	const [notifications, setNotifications] = useState<AlertMessage[]>([]);
	// const { notifications } = useNotificationStore();

	const orgRef = useRef<HTMLDivElement>(null);
	const orgAnchorRef = useRef<HTMLDivElement>(null);
	const notificationRef = useRef<HTMLDivElement>(null);
	const notificationAnchorRef = useRef<HTMLDivElement>(null);
	const settingRef = useRef<HTMLDivElement>(null);
	const settingAnchorRef = useRef<HTMLDivElement>(null);

	// const { setNotifications } = useNotificationStore();

	useEffect(() => {
		getUserDefaultOrganizationApi()
			.then((response) => {
				setDefault(response.data);
			})
			.catch((err) => {
				console.log(err);
			});
	}, [setDefault]);

	useEffect(() => {
		if (!defaultOrg) return;
		let parmas: any = {};
		if (defaultOrg.type === OrganizationType.Terminal) {
			parmas.terminalId = defaultOrg.id;
		} else if (defaultOrg.type === OrganizationType.Buyer) {
			parmas.buyerLedgerAccount = defaultOrg.ledgerAccountNumber;
		} else if (defaultOrg.type === OrganizationType.Vessel) {
			parmas.vesselLedgerAccount = defaultOrg.ledgerAccountNumber;
		}

		getAlertsApi({
			...parmas,
		})
			.then((response) => {
				//console.log(response.data);
				setNotifications(response.data);
			})
			.catch((error) => {
				console.log(error);
			});
	}, [defaultOrg]);

	useClickOutside(orgRef, (node) => {
		if (node.classList.contains("k-panelbar-item-text")) {
			return;
		}
		setShowOrganizations(false);
	});
	useClickOutside(notificationRef, () => {
		setShowNotification(false);
	});
	useClickOutside(settingRef, (node) => {
		if (node.classList.contains("k-panelbar-item-text")) {
			return;
		}
		setShowSetting(false);
	});

	useEscapeKey(() => {
		setShowSetting(false);
		setShowOrganizations(false);
		setShowNotification(false);
	});

	const getIcon = (type: OrganizationType) => {
		if (type === OrganizationType.Buyer) {
			return ICON_NAMES.Buyer;
		}

		if (type === OrganizationType.Vessel) {
			return ICON_NAMES.Vessel;
		}

		if (type === OrganizationType.Terminal) {
			return ICON_NAMES.Terminal;
		}
	};
	const toggleShowOrg = () => {
		setShowOrganizations(!showOrganizations);
		setShowNotification(false);
		setShowSetting(false);
	};

	const toggleNotification = () => {
		setShowNotification(!showNotification);
		setShowOrganizations(false);
		setShowSetting(false);
	};

	return (
		<div
			className="app-header-row"
			style={{
				display: "flex",
				height: "44px",
				paddingRight: 30,
				justifyContent: "space-between",
			}}
		>
			<div>
				{defaultOrg && (
					<div ref={orgRef} className="header-popover-anchor">
						<div ref={orgAnchorRef}>
							<Button
								style={{
									backgroundColor: "transparent",
									borderColor: "transparent",
									fontFamily: "Work Sans",
									fontSize: "15px",
									lineHeight: "18px",
									borderRadius: "12px",
									marginLeft: "-4px",
								}}
								startIcon={
									<img
										src={`/icon/${getIcon(defaultOrg?.type)}.svg`}
										alt={getIcon(defaultOrg?.type)}
										style={{}}
									/>
								}
								className="org-name"
								// onClick={() => console.log("fofoovo")}
								onClick={toggleShowOrg}
							>
								{defaultOrg.displayName}
							</Button>
						</div>
						<Popup
							anchor={orgAnchorRef.current}
							appendTo={orgRef.current}
							anchorAlign={{
								horizontal: "left",
								vertical: "bottom",
							}}
							popupAlign={{
								horizontal: "left",
								vertical: "top",
							}}
							show={showOrganizations}
							popupClass={"org-name-popup"}
							style={{
								borderRadius: "12px",
								background: "none",
							}}
						>
							<UserOrganization onSelect={() => setShowOrganizations(false)} />
						</Popup>
					</div>
				)}
			</div>

			<div style={{ display: "flex", gap: 1 }}>
				<div ref={notificationRef} className="header-popover-anchor">
					<div ref={notificationAnchorRef}>
						<Button
							style={{
								backgroundColor: "transparent",
								borderColor: "transparent",
								fontFamily: "Work Sans",
								lineHeight: "18px",
								borderRadius: "12px",
								marginRight: "0px",
							}}
							disabled={notifications.length === 0}
							aria-label={`Notifications (${notifications.length} unread)`}
							onClick={toggleNotification}
						>
							<BadgeContainer className="notification-badge-container">
								<img
									src={"/icon/notification.svg"}
									alt="notification"
									className="account-icon"
									// style={{ width: "28px", height: "28px" }}
								/>
								<Badge
									className=""
									align={{ horizontal: "start", vertical: "bottom" }}
									cutoutBorder={true}
									position="inside"
									rounded="full"
									size="small"
									themeColor="error"
									style={{
										display: notifications.length > 0 ? "block" : "none",
									}}
								>
									{notifications.length}
								</Badge>
							</BadgeContainer>
						</Button>
					</div>
					<Popup
						anchor={notificationAnchorRef.current}
						anchorAlign={{
							horizontal: "right",
							vertical: "bottom",
						}}
						popupAlign={{
							horizontal: "right",
							vertical: "top",
						}}
						show={showNotification}
						popupClass={"notification-popup"}
						style={{
							borderRadius: "12px",
							background: "none",
							//needed for mobile view,
							zIndex: 1300,
						}}
						margin={{ horizontal: -49, vertical: 0 }}
					>
						<div
							className="notification-popover-content"
							onClick={(event) => event.stopPropagation()}
							onMouseDown={(event) => event.stopPropagation()}
						>
							<Notification notifications={notifications} />
						</div>
					</Popup>
				</div>
				<div className="app-header-user-wrap" style={{}}>
					<div>
						<div ref={settingRef} className="header-popover-anchor">
							<div ref={settingAnchorRef}>
								<Button
									style={{
										backgroundColor: "transparent",
										borderColor: "transparent",
										fontFamily: "Work Sans",
										lineHeight: "18px",
										borderRadius: "12px",
										marginRight: "0px",
									}}
									onMouseOver={() => {
										setShowSetting(true);
										setShowOrganizations(false);
										setShowNotification(false);
									}}
									// onClick={(e) => setShowSetting(false)}
									className="user-setting-btn"
								>
									<img
										// onClick={() => setShowSetting(!showSetting)}
										src={"/icon/user.svg"}
										alt="account"
										className="account-icon"
										// style={{ width: "28px", height: "28px" }}
									/>
								</Button>
							</div>
							<Popup
								anchor={settingAnchorRef.current}
								appendTo={settingRef.current}
								anchorAlign={{
									horizontal: "right",
									vertical: "bottom",
								}}
								popupAlign={{
									horizontal: "right",
									vertical: "top",
								}}
								show={showSetting}
								popupClass={"user-setting-popup"}
								style={{
									borderRadius: "12px",
									background: "none",
								}}
							>
								<UserSetting onSelect={() => setShowSetting(false)} />
							</Popup>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HeaderItem;
